
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recycling/[post]",
      function () {
        return require("private-next-pages/recycling/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recycling/[post]"])
      });
    }
  